import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl';
import type { ChildIssueType } from '@atlassian/jira-issue-view-common-types/src/child-issue-type';
import { flowWithSafeComponent } from '@atlassian/jira-issue-view-common-utils';
import { connect } from '@atlassian/jira-issue-view-react-redux';
import { getIssueTypes } from '../../../state/entities/selectors';
import type { State } from '../../../state/types';
import { selectedIssueTypeChanged } from '../../../state/ui/actions';
import { getSelectedIssueType } from '../../../state/ui/selectors';

import ChildTypesSelect from './view';

type StateProps = {
	issueTypes: ChildIssueType[];
	selectedIssueType: ChildIssueType;
};

export default flowWithSafeComponent(
	injectIntl,
	// @ts-expect-error - TS2589 - Type instantiation is excessively deep and possibly infinite.
	connect(
		(state: State): StateProps => ({
			selectedIssueType: getSelectedIssueType(state),
			issueTypes: getIssueTypes(state),
		}),
		{
			onChange: selectedIssueTypeChanged,
		},
	),
)(ChildTypesSelect);
